<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Сервисный сбор</strong>
                </CCardHeader>
                <CCardBody>
                    <CRow class="ml-1 mb-3 mr-1">
                        <p>
                            Настройка сервисного сбора с заказа. Сервисный сбор распространяется
                            на все заказы МИР-СИТИ независимо от категории. Если настройка не задана,
                            по умолчанию используется сумма 49 рублей.
                        </p>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">
                            Включен
                        </CCol>
                        <CCol sm="9" class="d-flex align-items-center">
                            <CSwitch
                                color="primary"
                                :checked.sync="enabled"
                            />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">
                            Сумма сервисного сбора (руб.)
                        </CCol>
                        <CCol sm="9">
                            <CInput
                                v-model.number="amount"
                                type="number"
                                min="0"
                                step="1"
                                placeholder="49"
                            />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">
                            НДС (%)
                        </CCol>
                        <CCol sm="9">
                            <CInput
                                v-model.number="vatPercent"
                                type="number"
                                min="0"
                                max="100"
                                step="1"
                                placeholder="5"
                            />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">
                            Описание для пользователя
                        </CCol>
                        <CCol sm="9">
                            <CTextarea
                                v-model="description"
                                rows="3"
                                placeholder="Сервисный сбор помогает покрывать расходы на обработку заказов, работу службы поддержки и улучшение нашего сервиса."
                            />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">
                            Сноска в чеке
                        </CCol>
                        <CCol sm="9">
                            <CInput
                                v-model="receiptNote"
                                placeholder="Сервисный сбор за оформление и сборку заказа"
                            />
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton color="primary" @click="save()">Сохранить</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'ServiceFeeSettings',

        data() {
            return {
                key: 'service-fee',
                enabled: false,
                amount: 49,
                vatPercent: 5,
                description: 'Сервисный сбор помогает покрывать расходы на обработку заказов, работу службы поддержки и улучшение нашего сервиса.',
                receiptNote: 'Сервисный сбор за оформление и сборку заказа',
            };
        },

        mounted() {
            Vue.axios
                .get('/settings/' + this.key)
                .then(resp => {
                    if (resp.data && resp.data.value) {
                        const val = resp.data.value;
                        this.enabled = val.enabled || false;
                        this.amount = val.amount != null ? val.amount : 49;
                        this.vatPercent = val.vat_percent != null ? val.vat_percent : 5;
                        this.description = val.description || this.description;
                        this.receiptNote = val.receipt_note || this.receiptNote;
                    }
                })
                .catch(() => {
                    // Settings not yet created, use defaults
                });
        },

        methods: {
            save() {
                Vue.axios
                    .put('/settings/' + this.key, {
                        key: this.key,
                        value: {
                            enabled: this.enabled,
                            amount: this.amount,
                            vat_percent: this.vatPercent,
                            description: this.description,
                            receipt_note: this.receiptNote,
                        }
                    })
                    .then(() => {
                        this.$root.$emit('showSuccess', 'Настройки сервисного сбора сохранены.');
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка сохранения настроек.');
                    });
            },
        },
    };
</script>
